import RegisterForm from "../../components/RegisterForm/RegisterForm";
import PageStyle from "../../components/PageStyle";

const UserRegisterPage = () => {
  return (
    <PageStyle>
      <RegisterForm />
    </PageStyle>
  );
};

export default UserRegisterPage;
